]
<script setup lang="ts">
import { defineEmits, defineProps } from 'vue'

const props = withDefaults(
  defineProps<{
		modelValue: boolean | string | number
		trueValue?: string | number | boolean
		falseValue?: string | number | boolean
		disabled?: boolean
	}>(),
  {
    trueValue: true,
    falseValue: false,
    disabled: false,
  },
)

const emit = defineEmits<{
	(e: 'update:modelValue', value: typeof props.modelValue): void
}>()

const toggle = () => {
  if (props.disabled) return
  emit(
    'update:modelValue',
    props.modelValue === props.trueValue ? props.falseValue : props.trueValue,
  )
}
</script>

<template>
  <label class="inline-flex cursor-pointer select-none items-center gap-1">
    <input
      type="checkbox"
      :checked="modelValue === trueValue"
      :value="trueValue"
      :disabled="disabled"
      class="hidden"
      @change="toggle"
    >
    <div
      class="flex h-[30px] w-[30px] items-center justify-center p-1.5"
    >
      <div
        class="flex h-full w-full items-center justify-center rounded-[2px] "
        :class="modelValue === trueValue ? 'bg-white' : 'bg-transparent border-2 border-white/60'"
      >
        <svg
          v-if="modelValue === trueValue"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M3.33398 9.33398L5.66732 11.6673L12.6673 4.33398"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <slot />
  </label>
</template>
